import { render, staticRenderFns } from "./result4payermax.vue?vue&type=template&id=558b44b8&"
import script from "./result4payermax.vue?vue&type=script&lang=js&"
export * from "./result4payermax.vue?vue&type=script&lang=js&"
import style0 from "./result4payermax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports